<template>
  <div class="mt-24">
    <div class="el-card p-16 params-item">

      <el-cascader v-model="areaValue" ref="areaDropdown" class="fx-none" placeholder="全国" :show-all-levels="false" clearable :options="selectArea" collapse-tags
        :props="{multiple:true,children:'childOption',checkStrictly:false,emitPath:false}" />

      <TreeDropdown v-model="industryValue" placeholder="请选择产业链节点" multiple collapseTags showCheckbox checkStrictly nodeKey="nodeCode" :data="industryChain" :defaultProps="industryProps" />

      <el-date-picker v-model="time" ref="dataPicker" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
        :picker-options="pickerOptions" :clearable="false" style="width: 280px;">
      </el-date-picker>
      <!-- <TreeDropdown v-model="value2" placeholder="请选择事件" multiple collapseTags showCheckbox checkStrictly nodeKey="id" :data="treeData" /> -->
      <el-input v-model="companyName" placeholder="请输入公司名称" clearable size="large" style="width: 200px;"></el-input>

      <el-button @click="resetHandle">重置</el-button>
      <el-button type="primary" @click="searchHandle">查询</el-button>
    </div>
    <div class="fx mt-24 el-card-wrap pb-16">
      <div class="fx-full el-card p-16" style="padding-right: 0px !important;">
        <el-scrollbar ref="scrollbar" wrap-class="scrollbar-wrapper scrollbar-wrapper-maxheight" style="height:730px;">
          <div class="mr-16" v-infinite-scroll="load" infinite-scroll-disabled="disabled">
            <NewsDocument v-for="(item,i) in newsList" :data="item" :key="item.id" />
            <p v-if="loading" class="textAline">加载中...</p>
            <p v-if="newsList.length && noMore" class="textAline">- 没有更多了 -</p>
          </div>
          <EmptyBox v-if="!newsList.length&&!loading" style="color:#999;" />
        </el-scrollbar>
      </div>
      <div class="ml-24 fx-none" style="width: 500px;">
        <div class="el-card p-16 mb-24">
          <MyTitle class="mb-16">
            行业热门机构Top10
          </MyTitle>
          <el-table :data="tableData" style="width: 100%;" max-height="694">
            <el-table-column prop="name" label="机构名称" width="180">
            </el-table-column>
            <el-table-column prop="name" label="机构新闻数量">
              <template slot-scope="{row}">
                <el-progress :percentage="row.percentage" :format="p=>format(row)" :stroke-width="8" color="#186bfc"></el-progress>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- <div class="el-card p-16">
          <MyTitle class="mb-16">
            行业热度事件Top5
          </MyTitle>
          <div>
            <el-table :data="tableData2" style="width: 100%" max-height="300">
              <el-table-column prop="name" label="事件名称" width="180"></el-table-column>
              <el-table-column prop="name" label="事件新闻数量">
                <template slot-scope="{row}">
                  <el-progress :percentage="row.percentage" :format="p=>format(row)" :stroke-width="8" color="#186bfc"></el-progress>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div> -->
      </div>
    </div>

  </div>
</template>

<script>

import MyTitle from '@/views/industryChainNew/components/myTitle'
import NewsDocument from '@/views/industryChainNew/components/newsDocument'
import TreeDropdown from '@/components/treeDropdown/treeDropdown.vue'
import { getNewsPage, getNewsStat, getIndustryChain } from '@/views/industryChainNew/api'

import { mapState } from 'vuex'
import moment from 'moment'
function getDefaultTime() {
  const now = new Date()
  return [moment(now.getTime() - 3600 * 1000 * 24 * 90).format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]
}
export default {
  name: 'IndustryNews',
  components: {
    TreeDropdown,
    NewsDocument,
    MyTitle
  },
  props: {

  },
  data() {
    return {
      industryValue: [],
      industryChain: [],
      industryProps: {
        label: 'nodeName',
        disabled: function (data) {
          return !data.indirectSamNodeArray && !data.directSamNodeArray
        }
      },
      value2: '',
      companyName: '',
      time: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      tableData: [
        // {
        //   "code": "CSF0000002554",
        //   "name": "比亚迪股份有限公司",
        //   "count": 2452
        // },
      ],
      tableData2: [],
      newsList: [],
      lastAreaValue: [],
      areaValue: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      loading: false,
      cityParams: []
    }
  },
  computed: {
    ...mapState({
      selectArea: state => state.asyncRoute.selectArea,
      industryInfo: state => state.asyncRoute.industryInfo,

    }),
    ID() {
      return this.$route?.query?.id
    },
    noMore() {
      return this.total <= this.newsList.length
    },
    disabled() {
      return this.loading || this.noMore
    }
  },
  mounted() {
    this.time = getDefaultTime()
    this.getNewsStat()
    this.getNews()
    this.getIndustryChain()
  },
  methods: {
    format(row) {
      return row.count
    },
    async getIndustryChain() {
      const [err, res] = await this.$reqFn(getIndustryChain, {
        "isPart": 0,
        "productNodeCode": "",
        secId: this.ID
      })
      if (res && res.code === 200) {
        const { upStreams, middleStreams, downStreams } = res.data || {}
        this.industryChain = [...(upStreams || []), ...(middleStreams || []), ...(downStreams || [])]
      }
    },
    async getNewsStat() {
      const params = {
        areaCode: this.cityParams.length ? this.cityParams.map(e => e.value) : undefined,
        pageSize: 10,
        secId: this.ID,
        startDate: this.time[0],
        endDate: this.time[1]
      }

      const [err, res] = await this.$reqFn(getNewsStat, params)
      if (res && res.code == 200) {
        const { companyStat, eventStat } = res.data  // companyEvent
        this.tableData = companyStat?.map(e => {
          return { ...e, percentage: e.count / companyStat[0].count * 100 }
        })
        this.tableData2 = eventStat?.map(e => {
          return { ...e, percentage: e.count / eventStat[0].count * 100 }
        })
      }
    },
    load() {
      this.getNews()
    },
    getCityParams() {
      const newNodes = this.$refs.areaDropdown.getCheckedNodes()
      const lv = [
        [], [], []
      ]
      const cityParams = []

      newNodes.forEach(e => {
        lv[e.level - 1].push(e)
      })

      function delFn(index = 0, children) {
        const idx = index + 1
        if (children) {
          lv[index] = lv[index].filter(e => {
            if (children.some(c => c.value == e.value)) {
              idx < 3 && delFn(idx, e.children)
              return false
            }
            return true
          })
        }
      }
      function getLevelHigh(index = 0) {
        const idx = index + 1
        lv[index].forEach(e => {
          cityParams.push(e)
          idx < 3 && delFn(idx, e.children)
        })
        idx < 3 && getLevelHigh(idx)
      }
      getLevelHigh()
      this.cityParams = cityParams
      return cityParams
    },
    async getNews() {
      const productNodeCodes = []
      this.industryValue.forEach(e => {
        const directSamNodeArray = e.directSamNodeArray && JSON.parse(e.directSamNodeArray) || []
        const indirectSamNodeArray = e.indirectSamNodeArray && JSON.parse(e.indirectSamNodeArray) || []
        const arr = [...directSamNodeArray, ...indirectSamNodeArray]
        arr.forEach(ee => productNodeCodes.push(ee))
      })
      const params = {
        areaCode: this.cityParams.length ? this.cityParams.map(e => e.value) : undefined,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        secId: this.ID,
        startDate: this.time[0],
        endDate: this.time[1],
        companyName: this.companyName,
        productNodeCodes
      }

      const [err, res] = await this.$reqFn(getNewsPage, params, 'loading')
      if (res && res.code == 200 && res.data) {
        const { total, newsList } = res.data
        this.newsList = [...this.newsList, ...newsList]
        this.total = total
        this.pageNum++
      }
    },
    async resetHandle() {
      this.pageNum = 1
      this.time = getDefaultTime()
      this.companyName = ''

      this.$refs.areaDropdown.$refs.panel.clearCheckedNodes()
      this.$refs.areaDropdown.$refs.panel.activePath = []
      this.$refs.areaDropdown.$refs.panel.syncActivePath()
      await this.$nextTick()
      this.areaValue = []
      this.newsList = []
      this.getNews()
      this.getNewsStat()
    },
    searchHandle() {
      this.pageNum = 1
      this.newsList = []
      this.getCityParams()
      this.getNews()
      this.getNewsStat()
    }
  },
}
</script>

<style scoped lang="scss">
.el-card-wrap {
  align-items: flex-start;
}
.params-item {
  padding-bottom: 0 !important;
  & > div {
    margin-right: 16px;
    margin-bottom: 16px;
  }
}
::v-deep .el-table thead th.el-table__cell {
  background-color: #f4f6f9;
}
.textAline {
  text-align: center;
}
</style>
